// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s zku\u0161enost", "%(count)s zku\u0161enosti", "%(count)s zku\u0161enost\u00ed"];
export const WIKI_REVIEW_CATEGORY__counter_OF_PRODUCT_REVIEWS = ["%(counter)s produkt", "%(counter)s produkty", "%(counter)s produkt\u016f"];
